export const shadowColor = 'vec3(0.34, 0.43, 0.5)';
export const waterColor = 'vec3(0.86, 0.96, 0.99)';
export const underWaterDim = 0.6;


// WEBPACK FOOTER //
// ./src/js/shader/constants.js